import React from "react";
import './../modalBtn.css';



// import {copy} from './scripts';

const Modal = (props) => {
  const { id, category, description, tag, img, link } = props.data;

  // const copy = (that) => {
  //   var inp = document.createElement('input');
  //   document.body.appendChild(inp);
  //   inp.value = that.textContent;
  //   inp.select();
  //   document.execCommand('copy', false);
  //   inp.remove();
  // }

//   function copy(that){
// var inp =document.createElement('input');
// document.body.appendChild(inp)
// inp.value =that.textContent
// inp.select();
// document.execCommand('copy',false);
// inp.remove();
// }

  return (
    <div>
      <div className="modal show fade" style={{ display: "block" }}>
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                See Details Here
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={props.hide}
              ></button>
            </div>
            <div className="modal-body">
              <div className="row d-block d-md-none">
                <p className="text-secondary">NB: Image is not available in mobile devices or small devices.</p>
              </div>
              <div className="row">
                <div className="col-6 d-none d-md-block">
                  <img src={img} alt="img is not available in mobile device" className="img-fluid modal_img" />
                </div>
                <div className="col-md-6 col-12">
                  <h4 className="">Category: {category}</h4>

                  <p className="lead m-0 mb-1 d-inline-block" style={{ borderBottom: "1px solid lightgrey" }}>
                    Short Description:
                  </p>
                  <p className="text-secondary">{description}</p>

                  <button className="learn-more">
                    <span className="circle" aria-hidden="true">
                      <span className="icon arrow"></span>
                    </span>
                    <span className="button-text"><a href={link} target="_blank" className="visit_link">Visit Site</a></span>
                  </button>
                  
                  <p className="mt-2">Or simply you can copy the below link: <br/><span className="fw-bold text-success">{link}</span></p>

                  {/* <p className="mt-2">Or simply you can copy the below link: <br/><span className="fw-bold text-success" onClick={() => copy(this)}>{link}</span></p> */}

                  <p className="mt-3">Tag name: <span className="badge rounded-pill bg-warning text-dark"> {tag}</span></p>

                  <br />
                  <div className="d-grid gap-2 d-flex justify-content-start">
                    <button
                      type="button"
                      className="btn btn-outline-danger btn-block"
                      onClick={props.hide}
                    >
                      Close this pop up view
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
